export const CREATE_PRODUCT_REQUEST = 'product/CREATE_PRODUCT_REQUEST';
export const CREATE_PRODUCT_SUCCESS = 'product/CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_FAILURE = 'product/CREATE_PRODUCT_FAILURE';

export const READ_PRODUCT_REQUEST = 'product/READ_PRODUCT_REQUEST';
export const READ_PRODUCT_SUCCESS = 'product/READ_PRODUCT_SUCCESS';
export const READ_PRODUCT_FAILURE = 'product/READ_PRODUCT_FAILURE';

export const UPDATE_PRODUCT_REQUEST = 'product/UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'product/UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'product/UPDATE_PRODUCT_FAILURE';

export const UPDATE_PRODUCT_SCORES_REQUEST = 'product/UPDATE_PRODUCT_SCORES_REQUEST';
export const UPDATE_PRODUCT_SCORES_SUCCESS = 'product/UPDATE_PRODUCT_SCORES_SUCCESS';
export const UPDATE_PRODUCT_SCORES_FAILURE = 'product/UPDATE_PRODUCT_SCORES_FAILURE';

export const DELETE_PRODUCT_REQUEST = 'product/DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS = 'product/DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'product/DELETE_PRODUCT_FAILURE';

export const READ_PRODUCTS_REQUEST = 'product/READ_PRODUCTS_REQUEST';
export const READ_PRODUCTS_SUCCESS = 'product/READ_PRODUCTS_SUCCESS';
export const READ_PRODUCTS_FAILURE = 'product/READ_PRODUCTS_FAILURE';


// WEBPACK FOOTER //
// ./src/modules/product/product.actionTypes.js